import { API_BASE_URL } from "src/config/api";
import React, { useState } from 'react';
import {
  Grid,
  InputAdornment,
  IconButton,
  Button,
  CircularProgress,
  TextField,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function UpdatePassword() {
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: '',
  });

  const [isLoading, setIsLoading] = useState(false);
  const handlePasswordVisibilityToggle = () => {
    setPasswordVisible((prev) => !prev);
  };

  const handleConfirmPasswordVisibilityToggle = () => {
    setConfirmPasswordVisible((prev) => !prev);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      toast.error('New password and confirm password do not match.');
      return;
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    const token = urlSearchParams.get('token');

    if (token) {
      setIsLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}/updatePassword`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
        const data = await response.json();
        if (data.success === true) {
          toast.success(data.message || "New Password Updated Successfully.");
          setTimeout(() => {
            navigate('/Login', { replace: true });
          }, 2000);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        toast.error('An error occurred while updating the password.');
      } finally {
        setIsLoading(false);
      }
    } else {
      toast.error('The URL is incorrect or has expired.');
      setIsLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} disabled={isLoading}>
        <Grid container spacing={3} mt={1}>
          <Grid item xs={12} >
            <TextField
              name="newPassword"
              label="New Password"
              variant="outlined"
              fullWidth
              required
              type={passwordVisible ? 'text' : 'password'}
              value={formData.newPassword}
              onChange={(e) => {
                handleInputChange(e);
                e.target.reportValidity();
              }}
              inputProps={{
                minLength: 8,
                maxLength: 20,
                pattern: "(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@#$%^&+=]).{8,20}",
                title: "8–20 chars, include upper, lower, digit & symbol.",
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handlePasswordVisibilityToggle} edge="end">
                      {passwordVisible ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>


          {/* Confirm Password */}
          <Grid item xs={12} >
            <TextField
              name="confirmPassword"
              label="Confirm Password"
              variant="outlined"
              fullWidth
              required
              type={confirmPasswordVisible ? 'text' : 'password'}
              value={formData.confirmPassword}
              onChange={(e) => {
                handleInputChange(e);
                e.target.reportValidity();
              }}
              inputProps={{
                minLength: 8,
                maxLength: 20,
                pattern: formData.newPassword,
                title: "Make sure both passwords match exactly.",
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleConfirmPasswordVisibilityToggle} edge="end">
                      {confirmPasswordVisible ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12} >

              <Button
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                loading={isLoading.toString()}
              >
                {isLoading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : 'Submit'} 
              </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
}

export default UpdatePassword;
